import { render, staticRenderFns } from "./ImpactAmounts.vue?vue&type=template&id=1c4d89d1&"
import script from "./ImpactAmounts.vue?vue&type=script&lang=js&"
export * from "./ImpactAmounts.vue?vue&type=script&lang=js&"
import style0 from "./ImpactAmounts.vue?vue&type=style&index=0&id=1c4d89d1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports